import { tns } from 'tiny-slider/src/tiny-slider';

class BlockHistory {
	constructor(el) {
		this.el = el;

		const sliderContainer = this.el.querySelector('.block-history__slider');
		const navContainer = this.el.querySelector('.block-history__nav-container');

		const blockSlider = tns({
			container: sliderContainer,
			controls: false,
			autoHeight: true,
			axis: 'horizontal',
			swipeAngle: false,
			speed: 400,
			rewind: true,
			navContainer: navContainer,
			mouseDrag: true,
			slideBy: 'page',
			items: 1
		});
	}
}

export default BlockHistory;
